export default __webpack_public_path__ + "static/media/Xometry.12da4530.png";